var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-layout"},[_c('app-navbar'),_c('div',{staticClass:"router-container"},[_c('app-points-container'),_c('router-view')],1),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }